import Box from '@/common/components/Box'
import ButtonLink from '@/common/components/ButtonLink'
import InfoField from '@/common/components/InfoField'
import { RewardTicketData } from '@/common/types/rewardTickets.type'
import { MarkAsWinnerRaffleModal } from './MarkAsWinnerRaffleModal'
import { RejectRewardTicketModal } from './RejectRewardTicketModal'
import { twMerge } from 'tailwind-merge'
import { Dispatch, SetStateAction } from 'react'

interface RewardTicketProps {
  rewardTicket: RewardTicketData
  raffleId?: string
  isNextToAccept?: boolean
  setIsError: Dispatch<SetStateAction<boolean>>
  setMessages: Dispatch<SetStateAction<boolean | string[]>>
}

export default function RewardTicket({
  rewardTicket,
  raffleId,
  isNextToAccept,
  setIsError,
  setMessages,
}: RewardTicketProps) {
  const winPosition = rewardTicket?.win_position 
  const isRewardTicketWinner = winPosition === 1
  const ticketIsRejected = rewardTicket.status === 'rejected'
  const ticketIsAccepted = rewardTicket.status === 'accepted'

  const showRejectTicketButton = ticketIsAccepted || !ticketIsRejected

  return (
    <Box 
      className={twMerge(
        "flex flex-col flex-1 bg-white-100 gap-4",
        ticketIsAccepted && "bg-success-op",
        ticketIsRejected && "bg-danger-op"
      )}
    >
      <div className='flex items-center justify-between'>
        <span className='text-base font-bold'>
          {isRewardTicketWinner ? 'Ganhador' : `${winPosition}º colocado`}
        </span>

        <div className='flex items-center gap-2'>
          {showRejectTicketButton && (
            <RejectRewardTicketModal 
              rewardTicketId={rewardTicket.id} 
              raffleId={raffleId} 
              setIsError={setIsError}
              setMessages={setMessages}
            />
          )}
          {isNextToAccept && (
            <MarkAsWinnerRaffleModal 
              rewardTicketId={rewardTicket.id} 
              raffleId={raffleId} 
              setIsError={setIsError}
              setMessages={setMessages}
            />
          )}
        </div>
      </div>

      <div className='flex items-center justify-between'>
        <InfoField 
          className='flex-initial bg-transparent p-0'
          label='Nome' 
          labelClassName='italic'
          customInfo={
            <ButtonLink
              linkTo={`/tmais-users/${rewardTicket.user.id}`}
              operationKlassToCheckPermission='Establishment::Tmais::Users::Show'
            >
              {rewardTicket.user?.full_name}
            </ButtonLink>
          } 
        />
        <InfoField 
          className='flex-initial bg-transparent p-0 gap-0'
          label='Número sorteado' 
          labelClassName='italic'
          value={rewardTicket.number}
        />
      </div>

      <InfoField
        label='Email'
        value={rewardTicket.user?.email}
        className='flex-initial bg-transparent p-0 gap-0'
        labelClassName='italic'
        valueClassName='text-sm'
      />
    </Box>
  )
}
